<script lang="ts">
export default {
  name: 'KkLabelBrandedBadge'
}
</script>
<script lang="ts" setup>
import { computed } from 'vue'
import { KkBadge } from '../../../../components/base'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

type Props = {
  kind: string
}

const props = defineProps<Props>()

const isAccented = computed<boolean>(() => {
  return props.kind === t('models.analysis.searchQueriesDataType.searchKeywordLabelBranded.nonBranded')
})
</script>

<template>
  <KkBadge
    :text="props.kind"
    :background-color="isAccented ? '#4C959A' : '#E3E3E3'"
    :text-color="isAccented ? '#FFFFFF' : '#3A3B3F'"
  />
</template>
